import { useState, useEffect, useContext, useRef } from 'react';

import { SaleListContext } from '../SaleListContext';
import { SaleListSearchInput } from './input/SaleListSearchInput';
import { SaleListSearchLabel } from './label/SaleListSearchLabel';


export function SaleListSearch() {

  const isFullAccess = useContext(SaleListContext).isFullAccess;

  const searchTypeList = useContext(SaleListContext).searchTypeList;
  const grayColor = useContext(SaleListContext).grayColor;


  return (
    <div style={{
      position: 'sticky',
      top: 0,
      backgroundColor: grayColor,
      padding: '2% 4%',
    }}>

      {/* 入力検索 */}
      <SaleListSearchInput />

      {/* ラベル検索: フルアクセス意外 */}
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap', //はみ出さないように
        marginTop: 5 
      }}>
        {Object.entries(searchTypeList).map(([key, val]) => (
          <>
            {(
              !isFullAccess ||
              (isFullAccess && key=='favorite')
            ) &&
              <SaleListSearchLabel
                labelKey={key}
                isCheck={val}
              />
            }
          </>
        ))}
      </div>

    </div>
  );
}